import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './number-of-rooms.reducer';

export const NumberOfRoomsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const numberOfRoomsEntity = useAppSelector(state => state.numberOfRooms.entity);
  const loading = useAppSelector(state => state.numberOfRooms.loading);
  const updating = useAppSelector(state => state.numberOfRooms.updating);
  const updateSuccess = useAppSelector(state => state.numberOfRooms.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/number-of-rooms${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllHouseholds !== undefined && typeof values.totalAllHouseholds !== 'number') {
      values.totalAllHouseholds = Number(values.totalAllHouseholds);
    }
    if (values.oneRoom !== undefined && typeof values.oneRoom !== 'number') {
      values.oneRoom = Number(values.oneRoom);
    }
    if (values.twoRooms !== undefined && typeof values.twoRooms !== 'number') {
      values.twoRooms = Number(values.twoRooms);
    }
    if (values.threeRooms !== undefined && typeof values.threeRooms !== 'number') {
      values.threeRooms = Number(values.threeRooms);
    }
    if (values.fourRooms !== undefined && typeof values.fourRooms !== 'number') {
      values.fourRooms = Number(values.fourRooms);
    }
    if (values.fiveRooms !== undefined && typeof values.fiveRooms !== 'number') {
      values.fiveRooms = Number(values.fiveRooms);
    }
    if (values.sixRooms !== undefined && typeof values.sixRooms !== 'number') {
      values.sixRooms = Number(values.sixRooms);
    }
    if (values.sevenRooms !== undefined && typeof values.sevenRooms !== 'number') {
      values.sevenRooms = Number(values.sevenRooms);
    }
    if (values.eightRooms !== undefined && typeof values.eightRooms !== 'number') {
      values.eightRooms = Number(values.eightRooms);
    }
    if (values.nineOrMoreRooms !== undefined && typeof values.nineOrMoreRooms !== 'number') {
      values.nineOrMoreRooms = Number(values.nineOrMoreRooms);
    }

    const entity = {
      ...numberOfRoomsEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...numberOfRoomsEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.numberOfRooms.home.createOrEditLabel" data-cy="NumberOfRoomsCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.numberOfRooms.home.createOrEditLabel">Create or edit a NumberOfRooms</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="number-of-rooms-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.geographicLevel')}
                id="number-of-rooms-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.date')}
                id="number-of-rooms-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.geography')}
                id="number-of-rooms-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.geographyCode')}
                id="number-of-rooms-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.totalAllHouseholds')}
                id="number-of-rooms-totalAllHouseholds"
                name="totalAllHouseholds"
                data-cy="totalAllHouseholds"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.oneRoom')}
                id="number-of-rooms-oneRoom"
                name="oneRoom"
                data-cy="oneRoom"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.twoRooms')}
                id="number-of-rooms-twoRooms"
                name="twoRooms"
                data-cy="twoRooms"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.threeRooms')}
                id="number-of-rooms-threeRooms"
                name="threeRooms"
                data-cy="threeRooms"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.fourRooms')}
                id="number-of-rooms-fourRooms"
                name="fourRooms"
                data-cy="fourRooms"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.fiveRooms')}
                id="number-of-rooms-fiveRooms"
                name="fiveRooms"
                data-cy="fiveRooms"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.sixRooms')}
                id="number-of-rooms-sixRooms"
                name="sixRooms"
                data-cy="sixRooms"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.sevenRooms')}
                id="number-of-rooms-sevenRooms"
                name="sevenRooms"
                data-cy="sevenRooms"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.eightRooms')}
                id="number-of-rooms-eightRooms"
                name="eightRooms"
                data-cy="eightRooms"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfRooms.nineOrMoreRooms')}
                id="number-of-rooms-nineOrMoreRooms"
                name="nineOrMoreRooms"
                data-cy="nineOrMoreRooms"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/number-of-rooms" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default NumberOfRoomsUpdate;
